import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatFileSize } from 'utils/fileUtils';

export default ({ acceptedFiles }) => {
  const { t } = useTranslation();

  return (
    <>
      <h4>{t('datagate.external.submission.fileUpload.label.file')}</h4>
      <ul>
        {acceptedFiles.map(file => (
          <li className="word-break" key={file.path}>
            {file.path} - {formatFileSize(file.size)}
          </li>
        ))}
      </ul>
    </>
  );
};
